(function () {
  'use strict';

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) {
      el.classList.remove('is-open');
      el.hidden = true;
    } else {
      el.hidden = false;
    }
  }

  function setText(el, value) {
    if (!el) return;
    el.textContent = value || '';
  }

  function inQuickbuy(el) {
    return !!(closest(el, '.js-quickbuy') || closest(el, '.quickbuy-container') || closest(el, '.quickadd-container'));
  }

  function getAtcContainer(pf) {
    if (!pf) return null;
    return (
      pf.querySelector('[data-dynamic-variant-content$="-atc"]') ||
      pf.querySelector('.quantity-submit-row__submit')
    );
  }

  function resolveModal(ctx) {
    if (ctx.modalEl && document.contains(ctx.modalEl)) {
      bindModal(ctx.modalEl);
      return ctx.modalEl;
    }
    var m = ctx.pf ? ctx.pf.querySelector('[data-iz-quote-modal]') : null;
    if (!m && ctx.scope && !inQuickbuy(ctx.btn)) {
      m = document.querySelector('[data-iz-quote-modal][data-iz-scope="' + ctx.scope + '"]');
    }
    if (m) {
      ctx.modalEl = m;
      bindModal(m);
    }
    return m;
  }

  function bindModal(modal) {
    if (!modal || modal.getAttribute('data-iz-modal-bound') === '1') return;
    modal.setAttribute('data-iz-modal-bound', '1');

    modal.querySelectorAll('[data-iz-quote-close]').forEach(function (el) {
      el.addEventListener('click', function () { setHidden(modal, true); });
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.classList.contains('iz-quote-modal__overlay')) {
        setHidden(modal, true);
      }
    });

    var quoteForm = modal.querySelector('form.iz-quote-form');
    if (quoteForm) {
      quoteForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var payload = new URLSearchParams(new FormData(quoteForm)).toString();
        fetch(quoteForm.action, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: payload
        }).then(function (res) {
          if (res.ok) {
            var successEl = modal.querySelector('[data-iz-quote-success]');
            if (successEl) {
              quoteForm.style.display = 'none';
              successEl.removeAttribute('hidden');
            } else {
              setHidden(modal, true);
              alert('Your request has been submitted. We will contact you shortly.');
            }
          } else {
            alert('There was an error submitting your request. Please try again.');
          }
        }).catch(function () {
          alert('There was an error submitting your request. Please try again.');
        });
      });
    }
  }

  function getGroupProductUrl(ctx) {
    var qb = closest(ctx.pf, '.js-quickbuy') ||
             closest(ctx.pf, '.quickbuy-container') ||
             closest(ctx.pf, '.quickadd-container');
    if (qb && qb.dataset && qb.dataset.productUrl) return qb.dataset.productUrl;
    var jsonEl = ctx.pf ? ctx.pf.querySelector('[data-product-json]') : null;
    if (jsonEl) {
      try {
        var d = JSON.parse(jsonEl.textContent);
        if (d && d.handle) return '/products/' + d.handle;
      } catch (ignore) {}
    }
    
    
    
    
    
    
    
    
    var link = inQuickbuy(ctx.pf) ? ctx.pf.querySelector('a[href*="/products/"]') : null;
    if (link) return link.getAttribute('href');
    return null;
  }

  function fetchModalFor(ctx, done) {
    if (ctx.modalFetchState === 'pending' || ctx.modalFetchState === 'failed') return;
    var url = getGroupProductUrl(ctx);
    if (!url) { ctx.modalFetchState = 'failed'; return; }
    ctx.modalFetchState = 'pending';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var found = doc.querySelector('[data-iz-quote-modal]');
        if (!found) { ctx.modalFetchState = 'failed'; return; }
        var imported = document.importNode(found, true);
        
        
        
        imported.removeAttribute('data-iz-scope');
        imported.setAttribute('hidden', '');
        document.body.appendChild(imported);
        ctx.modalEl = imported;
        ctx.modalFetchState = 'done';
        bindModal(imported);
        if (typeof done === 'function') done(imported);
      })
      .catch(function () { ctx.modalFetchState = 'failed'; });
  }

  function openModal(ctx, modal) {
    if (!modal) return;
    var successEl = modal.querySelector('[data-iz-quote-success]');
    var quoteForm = modal.querySelector('form.iz-quote-form');
    if (successEl) successEl.hidden = true;
    if (quoteForm) quoteForm.style.display = '';
    populate(ctx, modal, ctx.currentVariant);
    modal.removeAttribute('hidden');
    modal.classList.add('is-open');
  }

  function getProductTitle(pf) {
    
    var selectors = ['.product__title', '.product-single__title', 'h1.title', 'h1'];
    for (var i = 0; i < selectors.length; i++) {
      var el = (pf ? pf.querySelector(selectors[i]) : null) || document.querySelector(selectors[i]);
      if (el) return el.textContent.trim();
    }
    return '';
  }

  function getSelectedOptions(form) {
    var opts = [];
    
    form.querySelectorAll('[name^="options"]').forEach(function (el) {
      if (el.tagName === 'SELECT') {
        opts.push(el.value);
      } else if (el.type === 'radio' && el.checked) {
        opts.push(el.value);
      } else if (el.type !== 'radio') {
        opts.push(el.value);
      }
    });
    return opts;
  }

  function populate(ctx, modal, variant) {
    if (!modal) return;

    var productTitle = getProductTitle(ctx.pf);
    
    var variantTitle = (variant && variant.title && variant.title !== 'Default Title')
      ? variant.title
      : getSelectedOptions(ctx.form).join(' / ');
    var sku = variant ? (variant.sku || '') : '';

    setText(modal.querySelector('[data-iz-quote-product-text]'), productTitle);
    setText(modal.querySelector('[data-iz-quote-variant-text]'), variantTitle);
    setText(modal.querySelector('[data-iz-quote-sku-text]'), sku);

    var inp = modal.querySelector('[data-iz-quote-product]');
    if (inp) inp.value = productTitle;
    var vi = modal.querySelector('[data-iz-quote-variant]');
    if (vi) vi.value = variantTitle;
    var vid = modal.querySelector('[data-iz-quote-variant-id]');
    if (vid) vid.value = variant ? variant.id : '';
    var sk = modal.querySelector('[data-iz-quote-sku]');
    if (sk) sk.value = sku;
    var urlEl = modal.querySelector('[data-iz-quote-url]');
    if (urlEl) urlEl.value = window.location.href;
    var body = modal.querySelector('[data-iz-quote-body]');
    if (body) {
      body.value = 'Product: ' + productTitle +
                   '\nVariant: ' + variantTitle +
                   '\nSKU: ' + sku +
                   '\nURL: ' + window.location.href;
    }
  }

  function syncStickyQuote(quoteEligible) {
    var bar = document.querySelector('sticky-atc');
    if (!bar) return;
    var qBtn = bar.querySelector('[data-iz-sticky-quote]');
    if (!qBtn) return;
    var native = bar.querySelector('.sticky-atc__buttons form') ||
                 bar.querySelector('.sticky-atc__buttons > a.btn');
    if (quoteEligible) {
      qBtn.hidden = false;
      if (native) native.style.setProperty('display', 'none', 'important');
    } else {
      qBtn.hidden = true;
      if (native) native.style.removeProperty('display');
    }
  }

  function applyState(ctx, variant) {
    ctx.currentVariant = variant; 
    var quoteEligible = !!(
      variant &&
      variant.available === false &&
      variant.inventory_policy !== 'continue'
    );
    var atc = getAtcContainer(ctx.pf);

    if (quoteEligible) {
      populate(ctx, resolveModal(ctx), variant);
      if (atc) atc.style.setProperty('display', 'none', 'important');
      if (ctx.submitWrap) ctx.submitWrap.style.display = 'flex';
    } else {
      if (atc) atc.style.removeProperty('display');
      if (ctx.submitWrap) ctx.submitWrap.style.display = 'none';
      setHidden(resolveModal(ctx), true);
    }

    
    
    if (!inQuickbuy(ctx.pf)) {
      syncStickyQuote(quoteEligible);
    }
  }

  function getProductHandle() {
    var handleEl = document.querySelector('[data-product-handle]');
    if (handleEl && handleEl.dataset.productHandle) return handleEl.dataset.productHandle;
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function initQuoteGroup(btn) {
    var scope = btn.dataset.izScope || '';
    var pf = closest(btn, 'product-form');
    var form = pf ? pf.querySelector('form') : null;
    if (!pf || !form) return false;

    var submitWrap = closest(btn, '[data-iz-quote-submit]') || btn.parentElement;

    var ctx = {
      btn: btn, scope: scope, pf: pf, form: form, submitWrap: submitWrap,
      currentVariant: null, variants: null, modalEl: null, modalFetchState: null
    };

    
    btn.addEventListener('click', function () {
      var modal = resolveModal(ctx);
      if (modal) { openModal(ctx, modal); return; }
      
      
      fetchModalFor(ctx, function (m) { openModal(ctx, m); });
    });

    
    function onVariantChange(e) {
      var detail = e.detail || {};
      var variant = detail.variant || (detail.product && detail.product.selected_variant);
      if (!variant) return;
      if (ctx.pf && e.target && e.target !== ctx.pf && !ctx.pf.contains(e.target)) return;
      
      
      
      var full = null;
      if (ctx.variants) {
        full = ctx.variants.find(function (v) { return String(v.id) === String(variant.id); });
      }
      applyState(ctx, full || variant);
    }

    document.addEventListener('on:variant:change', onVariantChange);

    
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return true;

    var selectedId = idInput.value;

    function applyFromVariants(variants) {
      ctx.variants = variants;
      var v = variants.find(function (vr) {
        return String(vr.id) === String(selectedId);
      });
      if (v) {
        applyState(ctx, v);
      } else {
        if (submitWrap) submitWrap.style.display = 'none';
      }
    }

    
    var jsonEl = document.getElementById('product-json-' + scope) ||
                 document.getElementById('ProductJson-' + scope);
    if (jsonEl) {
      try {
        var productData = JSON.parse(jsonEl.textContent);
        if (productData && productData.variants) {
          applyFromVariants(productData.variants);
          return true;
        }
      } catch (ignore) {}
    }

    
    
    var ownUrl = getGroupProductUrl(ctx);
    var handle = null;
    if (ownUrl) {
      var mm = ownUrl.match(/\/products\/([^/?#]+)/);
      if (mm) handle = mm[1];
    }
    if (!handle) handle = getProductHandle();

    if (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) { applyFromVariants(data.variants || []); })
        .catch(function () { if (submitWrap) submitWrap.style.display = 'none'; });
    } else {
      if (submitWrap) submitWrap.style.display = 'none';
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var sticky = e.target.closest('[data-iz-sticky-quote]');
    if (!sticky) return;
    e.preventDefault();
    var mainBtn = null;
    document.querySelectorAll('[data-iz-quote-open]').forEach(function (b) {
      if (mainBtn || inQuickbuy(b)) return;
      mainBtn = b;
    });
    if (mainBtn) mainBtn.click();
  });

  function izInitAll() {
    document.querySelectorAll('[data-iz-quote-open]').forEach(function (btn) {
      if (btn.dataset.izQuoteInit === '1') return;
      if (initQuoteGroup(btn) !== false) {
        btn.dataset.izQuoteInit = '1';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(izInitAll, 100);
  });

  document.addEventListener('on:quickbuy:after-open', function () {
    setTimeout(izInitAll, 150);
    setTimeout(izInitAll, 600);
    setTimeout(izInitAll, 1200);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(izInitAll, 100);
  });

})();
